const routesPaths = {
  dashboard: "/",
  login: "/login",
  forgotPassword: "/forgot-password",
  emailConfirm: "/email-confirm",
  resetPassword: "/reset-password/:resetCode",
  signUp: "/sign-up",
  referral: "/r/:refferalCode",
  wallet: "/wallet",
  history: "/history",
  games: "/games",
  documentForm: "/document-form",
  adminRedirect: "/admin-redirect",
  membership: "/membership",
  claim: "/claim",

  futures: "/futures",
  futuresBalances: "/futures/balances",

  cryptoTransfers: "/crypto-transfers",
  buyCrypto: "/crypto-transfers/buy-crypto",
  sellCrypto: "/crypto-transfers/sell-crypto",
  cryptoWidget: "/crypto-transfers/widget",

  earning: "/earning",
  liquidityPool: "/earning/liquidity-pool",
  copyTrading: "/earning/copy-trading",
  copyTradingStake: "/earning/copy-trading/stake",

  cryptoCards: "/crypto-cards",
  cryptoCardsProducts: "/crypto-cards/products",
  cryptoCardPurcahse: "/crypto-cards/products/",
  cryptoCardPurcahseFull: "/crypto-cards/products/:productId",
  cryptoCardPhysicalProduct: "/crypto-cards/products/physical/",
  cryptoCardPhysicalProductFull: "/crypto-cards/products/physical/:productId",
  usersCryptoCard: "/crypto-cards/user/crypto/",
  usersCryptoCardFull: "/crypto-cards/user/crypto/:cardId",

  giftCards: "/gift-cards",
  giftCardsProducts: "/gift-cards/products",
  giftCardPurchase: "/gift-cards/products/",
  giftCardPurchaseFull: "/gift-cards/products/:productId",
  usersGiftCard: "/gift-cards/user/gift/",
  usersGiftCardFull: "/gift-cards/user/gift/:cardId",

  profile: "/profile",
  verification: "/profile/verification",
  activityLog: "/profile/activity-log",
  referrals: "/profile/referrals",
  documents: "/profile/documents",
  notifications: "/profile/notifications",

  trade: "/trade",
  openOrders: "/trade/open-orders",
  closedOrders: "/trade/closed-orders",
};

export default routesPaths;
